import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { CampaignDrawerOpen, DEFAULT_DRAWER_STATE } from '@finder/shared/services/campaign-drawer/campaign-drawer.interface';
import { CampaignDrawerService } from '@finder/shared/services/campaign-drawer/campaign-drawer.service';
import { CampaignDrawerBase } from '@finder/shared/components/campaign-drawer-base/campaign-drawer-base';
import { ConfigService } from '@finder/core/config.service';
import { FinderAnalyticsService } from '@finder/shared/services/finder-analytics/finder-analytics.service';
import { HashTriggerableService } from '@finder/shared/features/hash-triggerable/hash-triggerable.service';
import { UrlParamsService } from '@finder/shared/services/url-params/url-params.service';
import { SECTION_ICONS } from '../section/section.constants';
import { CommonModule } from '@angular/common';
import { ComponentHeaderComponent } from '../component-header/component-header.component';
import { FontIconComponent } from '../font-icon/font-icon.component';
import { ScrollToDirective } from '@finder/shared/directives/scroll-to/scroll-to.directive';
import { SafeHtmlPipe } from '@finder/shared/utils/pipes/safe-html/safe-html.pipe';
import { CampaignDrawerDetailComponent } from '../campaign-drawer-detail/campaign-drawer-detail.component';
@Component({
    selector: 'finder-campaign-drawer-link',
    templateUrl: './campaign-drawer-link.component.html',
    styleUrls: ['./campaign-drawer-link.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        FontIconComponent,
        ScrollToDirective,
        SafeHtmlPipe,
        CampaignDrawerDetailComponent,
    ]
})
export class CampaignDrawerLinkComponent extends CampaignDrawerBase implements OnInit {
    @Input() drawerData;
    @Input() linkId;

    norgieClosed = SECTION_ICONS.name.closed;
    norgieOpened = SECTION_ICONS.name.opened;
    norgie: string;
    protected sourceId: string;

    constructor(
        private configService: ConfigService,
        private finderAnalyticsService: FinderAnalyticsService,
        private urlParamsService: UrlParamsService,
        protected drawerService: CampaignDrawerService,
        protected route: ActivatedRoute,
        protected hashTriggerableService: HashTriggerableService,
    ) {
        super(hashTriggerableService, route, drawerService);
    }

    ngOnInit(): void {
        // Hash trigger
        this.elementId = this.linkId;

        //Source id to be focused back on drawer close
        this.sourceId = `${this.elementId}-link`;

        // Init norgie
        this.norgie = this.norgieClosed;

        // Call super
        super.ngOnInit();
    }

    override click(event) {
        super.click(event);

        // Act depending on the current state
        if (this.isExpanded) {
            // Broadcast that the drawer state has changed
            this.setOpen();

            // Update the hash
            this.hashTriggerableService.updateHash(this.linkId);
        } else {
            // Broadcast that the drawer state has changed
            this.drawerService.setOpen(DEFAULT_DRAWER_STATE);

            // Update the hash
            this.hashTriggerableService.removeHash();
        }

        const faqItemState = this.isExpanded ? 'expanded' : 'collapsed';

        // Analytics tracking
        this.finderAnalyticsService.updateModelAndTrack({
            linkId: `${this.configService.getValue('siteId')}_${this.urlParamsService.entityType}_${this.linkId}_${faqItemState}`
        });

        // this.eventTrigger = true;
    }

    protected expand() {
        // Make sure we don't keep calling this over and over
        if (this.isExpanded) {
            return;
        }

        super.expand();

        // If this is triggered from a page load broadcast to everyone
        if (this.hashTriggerableService.isTriggered) {
            this.setOpen();
        }

        // Set norgie
        this.norgie = this.norgieOpened;

        // Reset the hash trigger flag
        this.hashTriggerableService.disableTrigger();
    }

    protected collapse() {
        // Make sure we don't keep calling this over and over
        if (!this.isExpanded) {
            return;
        }

        super.collapse();

        // Set norgie
        this.norgie = this.norgieClosed;
    }

    protected onOpen(data: CampaignDrawerOpen) {
        if (!this.linkId) {
            return;
        }

        if (this.linkId !== data.groupId) {
            return this.collapse();
        }
        this.expand();
    }

    protected setOpen() {
        this.drawerService.setOpen({
            groupId: this.linkId,
            cardIndex: 1,
            cardData: {
                close: this.drawerData.close,
                title: this.drawerData.title,
                topLink: this.drawerData.topLink,
                viewMoreSubtitle: this.drawerData.copy,
                viewMoreTitle: this.drawerData.header,
            },
            hasHash: false,
            sourceId: this.sourceId,
        });
    }
}
